/* global getCookieItem:false */
/* global getStorageItem:false */
/* global removeStorageItem:false */
/* global setStorageItem:false */
/* global throttle:false */
/* global window:false */

(function() {
	var get_params = function(search_string) {
		var parse = function(params, pairs) {
			var pair = pairs[0];
			var parts = pair.split('=');
			var key = decodeURIComponent(parts[0]);
			var value = decodeURIComponent(parts.slice(1).join('='));

			// handle multiple parameters of the same name
			if (typeof params[key] === 'undefined') {
				params[key] = value;
			} else {
				params[key] = [].concat(params[key], value);
			}

			return pairs.length === 1 ? params : parse(params, pairs.slice(1));
		};

		// get rid of leading ?
		return search_string.length === 0 ? {} : parse({}, search_string.substr(1).split('&'));
	};

	var revealWidget = function(id, code) {
		var widget = document.getElementById('js-campaign-widget-' + id);
		var widgetType = widget.getAttribute('data-type');
		var widgetContainer = document.getElementById('js-campaign-widget-container');
		var excludedWidgetType = widgetContainer.getAttribute('data-excluded-type');

		if (widgetType == excludedWidgetType) {
			return false;
		}

		if (widget) {
			widget.classList.add('campaign-widget--reveal-animation');

			setTimeout(() => {
				widget.classList.add('campaign-widget--visible');
			}, 300);

			var closeElements = widget.querySelectorAll('[data-close]');
			Array.prototype.forEach.call(closeElements, function(closeElement) {
				closeElement.addEventListener('click', (e) => {
					e.preventDefault();

					if (!widget.classList.contains('campaign-widget--reveal-animation')) {
						widget.classList.add('campaign-widget--reveal-animation');
					}

					widget.classList.remove('campaign-widget--visible');

					setTimeout(() => {
						widget.classList.remove('campaign-widget--reveal-animation');
					}, 500);

					setStorageItem('widget_closed_at', Date.now());
				});
			});
		}
	};

	var getWidget = function(id) {
		var isUserLoggedIn = getStorageItem('account_logged_in');

		// don't fetch widget when user is logged in
		if (isUserLoggedIn) {
			return false;
		}

		// don't fetch widget on pages without widget container (#js-campaign-widget-container)
		var widgetContainer = document.getElementById('js-campaign-widget-container');
		if (!widgetContainer) {
			return false;
		}

		var request = new XMLHttpRequest();
		request.open('GET', '/lazy-content/widgets/' + id + '/index.html', true);

		request.onload = function() {
			if (this.status >= 200 && this.status < 400) {
				var code = this.response;

				widgetContainer.innerHTML += code;
				var type = widgetContainer.querySelector('#js-campaign-widget-' + id).getAttribute('data-type');

				var campaignWidgetId = getStorageItem('widget_id');
				if (!campaignWidgetId) {
					setStorageItem('widget_id', id);
					setStorageItem('widget_type', type);
				}

				// specific replacement for notification widgets
				var newTrialsCount = getStorageItem('new_trials_count');
				if (id === 'trials-notification' && newTrialsCount) {
					const countElements = widgetContainer.querySelectorAll('.js-trial-notification-people-count');
					Array.prototype.forEach.call(countElements, function(element) {
						try {
							element.innerHTML = new Intl.NumberFormat('en-US').format(newTrialsCount);
						} catch(e) {
							element.innerHTML = newTrialsCount;
						}
					});
				}

				revealWidget(id);
			}
		};

		request.send();
	};



	/**
	 * Specific scroll listener for notification widget
	 *
	 * We will try to calculate whether we already scrolled 1.5 height of screen size
	 * and if yes we will display special notification widget
	 */

	const notificationWidgetScrollListener = throttle(function() {
		var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

		if (scrollTop * 1.5 > window.innerHeight) {
			var newTrialsCount = getStorageItem('new_trials_count');

			if (newTrialsCount) {
				getWidget('trials-notification');

				window.removeEventListener('scroll', notificationWidgetScrollListener);
			}
		}
	}, 150, {
		leading: true,
		trailing: true,
	});



	var params = get_params(window.location.search);
	var campaignSource = false;

	if (params.ref) {
		campaignSource = params.ref;
		removeStorageItem('widget_closed_at');
		removeStorageItem('widget_id');
		getWidget(params.ref);
	} else {
		if (params.utm_source) {
			campaignSource = params.utm_source;
		} else if (params.utm_campaign) {
			campaignSource = params.utm_campaign;
		}

		var campaignWidgetId = getStorageItem('widget_id');

		// when widget is disabled, it won't be visible for next 14 days
		var campaignWidgetDisabledTimestamp = getStorageItem('widget_closed_at');
		var timestampBeforeTwoWeeks = new Date(new Date().getTime() - (14 * 24 * 60 * 60 * 1000)).getTime();
		var isCampaignWidgetDisabled = campaignWidgetDisabledTimestamp && campaignWidgetDisabledTimestamp > timestampBeforeTwoWeeks;

		if (!isCampaignWidgetDisabled) {
			if (campaignWidgetId) {
				if (campaignWidgetId == 'trials-notification') {
					window.addEventListener(
						'scroll',
						notificationWidgetScrollListener,
						{
							passive: true,
						}
					);
				} else {
					getWidget(campaignWidgetId);
				}
			} else {
				window.addEventListener(
					'scroll',
					notificationWidgetScrollListener,
					{
						passive: true,
					}
				);
			}
		}
	}

	// manualy set campaign widget when user will visit specific campaign URL directly (without ref GET attribute)
	var newWidgetData = document.getElementsByTagName('body')[0].getAttribute('data-set-widget');
	if (newWidgetData) {
		newWidgetData = newWidgetData.split(',');
		var newWidgetId = newWidgetData[0];
		var newWidgetType = newWidgetData[1];

		var campaignWidgetId = getStorageItem('widget_id');
		var campaignWidgetType = getStorageItem('widget_type');

		// when widget is disabled, it won't be visible for next 14 days
		var campaignWidgetDisabledTimestamp = getStorageItem('widget_closed_at');
		var timestampBeforeTwoWeeks = new Date(new Date().getTime() - (14 * 24 * 60 * 60 * 1000)).getTime();
		var isCampaignWidgetDisabled = campaignWidgetDisabledTimestamp && campaignWidgetDisabledTimestamp > timestampBeforeTwoWeeks;

		if (!campaignWidgetId || (!isCampaignWidgetDisabled && newWidgetType == campaignWidgetType)) {
			setStorageItem('widget_id', newWidgetId);

			if (!campaignWidgetType) {
				setStorageItem('widget_type', newWidgetType);
			}

			campaignSource = newWidgetId;

			getWidget(newWidgetId);
		}
	}

	// Special condition for IMU partners only (redirect from URL /partner/imu/ -> ./?a=martijnvantongerenm)
	if (params.a && params.a == 'martijnvantongerenm') {
		campaignSource = 'imu';
	}

	if (campaignSource.length > 0) {
		setStorageItem('campaign_id', campaignSource);
		setStorageItem('campaign_created_at', Date.now());
	}

	// transform old cookies to new local storage item
	var deprecatedCookie = getCookieItem('campaign-source');
	if (deprecatedCookie) {
		setStorageItem('campaign_id', deprecatedCookie);
		setStorageItem('campaign_created_at', Date.now());
	}

	// expiration of old campaign_ids after 90 days
	var campaignTimestamp = getStorageItem('campaign_created_at');
	var timestampBefore90Days = new Date(new Date().getTime() - (90 * 24 * 60 * 60 * 1000)).getTime();
	var isCampaignExired = campaignTimestamp && campaignTimestamp < timestampBefore90Days;
	if (getStorageItem('campaign_id') && isCampaignExired) {
		removeStorageItem('campaign_id');
		removeStorageItem('campaign_created_at');
	}
})();
